import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  user: null,
  response: null,
  loading: false,
  error: null,
  callTimes : 0,
  message:'',
  token:null
};

const userData = localStorage.getItem('user') ? localStorage.getItem('user') : null ;
if(userData && userData !== "undefined"){
    try {
        initialState.response = JSON.parse(userData);
        initialState.token = initialState.response?.access_token;
    } catch (e) {
        localStorage.removeItem('user');
        initialState.response = null;
    }
}else{
    initialState.response =  null;
}

export const userSlice = createSlice({
  name: 'user',
  initialState,
  reducers: {
    signup : (state) => {
        state.callTimes++;
    },
    signin :(state) =>  {
        state.callTimes++;
    },
    failed: (state, {payload}) => {
        state.error = true;
        state.loading = false;
        state.message = payload?.message || payload?.data?.message || 'Login failed';
    },

    success : (state, {payload})=>{
        const userObj = payload?.data?.user;
        const accessToken = payload?.data?.access_token;
        
        if (!userObj || userObj.role !== 'admin') {
            state.loading = false;
            state.error = true;
            state.message = 'Access Denied: Only administrators can log in here.';
            state.response = null;
            state.token = null;
            return;
        }

        if (userObj) {
            localStorage.setItem('user', JSON.stringify(userObj));
        }
        if (accessToken) {
            localStorage.setItem('token', accessToken);
        }
        
        state.loading = false;
        state.response = payload?.data;
        state.message = payload?.data?.message || 'Success';
        state.token = accessToken;
        state.error = null;
    },
    logout : (state)=>{
      localStorage.removeItem('user');
      localStorage.removeItem('token');
      localStorage.removeItem('userToken');
      localStorage.removeItem('admin_last_activity');
      sessionStorage.removeItem('userToken');
      sessionStorage.clear();
      state.response = null;
      state.loading = false;
      state.message = 'Logout Successfully';
    }
  },
})

// Action creators are generated for each case reducer function
export const { signup, signin, success, failed, logout } = userSlice.actions

export default userSlice.reducer